import { Color } from '@diritto/common/style/color';

export const DeleteIcon = ({ color = Color.Gray700 }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 9H6V21H18V9Z" fill={color} />
    <path d="M10 4V5H6V7H18V5H14V4H10Z" fill={color} />
  </svg>
);
